// extracted by mini-css-extract-plugin
module.exports = {"toc_footer":"tocFooter_toc_footer__Om0uh","copy":"tocFooter_copy__2luQG","link":"tocFooter_link__ApE6d","right":"tocFooter_right__uxAOo"};